/**
 * Shared layout constants for the calendar grid family. These were inlined
 * in the original calendar.tsx; extracting them here so day/week/month/
 * resource grids agree on geometry without circular imports.
 */

export const DAY_START_HOUR = 7;
export const DAY_END_HOUR = 20;
export const MINUTES_PER_ROW = 15;
export const ROW_HEIGHT_PX = 16;

/** Total rows in a single-day vertical timeline (DAY_START_HOUR → DAY_END_HOUR). */
export const TOTAL_ROWS = ((DAY_END_HOUR - DAY_START_HOUR) * 60) / MINUTES_PER_ROW;

/** Snap an arbitrary minute count to the closest multiple of `increment`. */
export function snapMinutes(minutes: number, increment: number): number {
  return Math.round(minutes / increment) * increment;
}
